import { combineReducers } from 'redux'
import CountReducer from './Count'

export const AllReducer = combineReducers({
  count: CountReducer,
})
